import { clsx } from 'clsx';

/**
 * Utility for merging Tailwind CSS classes with proper conflict resolution.
 * Uses clsx for conditional class joining.
 *
 * @example
 * // Basic usage
 * cn('px-4 py-2', 'bg-brand-500')
 * // => 'px-4 py-2 bg-brand-500'
 *
 * @example
 * // With conditionals
 * cn('btn', isActive && 'btn-active', isDisabled && 'opacity-50')
 * // => 'btn btn-active' (if isActive is true, isDisabled is false)
 *
 * @example
 * // Object syntax
 * cn('btn', { 'btn-active': isActive, 'opacity-50': isDisabled })
 *
 * @param {...(string|object|array|undefined|null|false)} inputs - Class values to merge
 * @returns {string} Merged class string
 */
export function cn(...inputs) {
  return clsx(inputs);
}

export default cn;
